import { CommonModule } from '@angular/common';
import { ComponentFactoryResolver, DOCUMENT, Type } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ConfigModule } from 'NewAngular/config/config.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import { BaseSecurityPageModule } from 'SecuritiesApp/ts/apps/base-security-page/app.module';
import { PieChartComponent } from 'ChartApp/ts/features/pie-chart/pie-chart.component';
import { TopBarNavComponent } from 'NewAngular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { SideMenuComponent } from 'NewAngular/features/components/side-menu/side-menu.component';
import { SecurityHeaderControlComponent } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.component';
import { DoVariableBootstrap } from 'SecuritiesApp/ts/extendable-classes/do-variable-bootstrap';
import * as i0 from "@angular/core";
const entryComponents = [SideMenuComponent, SecurityHeaderControlComponent, TopBarNavComponent];
export class MutualFundsAllocationsAppModule extends DoVariableBootstrap {
    constructor(_document, componentFactoryResolver) {
        super(_document, componentFactoryResolver, entryComponents);
        this.nonSingularComponents = [PieChartComponent];
    }
}
MutualFundsAllocationsAppModule.ɵfac = function MutualFundsAllocationsAppModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MutualFundsAllocationsAppModule)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i0.ComponentFactoryResolver)); };
MutualFundsAllocationsAppModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MutualFundsAllocationsAppModule });
MutualFundsAllocationsAppModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BaseSecurityPageModule, CommonModule, ConfigModule, FormsModule, IconModule, TooltipModule] });
